import { FC } from 'react';

import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Select from 'src/components/Form/Select';
import { Item } from 'src/components/Form/Select/interfaces';
import TextField from 'src/components/Form/TextField';

const statusItems: Item[] = [
  { key: 1, label: 'Ativo', value: 'active' },
  { key: 2, label: 'Inativo', value: 'inactive' },
];

const UserFilters: FC = () => {
  return (
    <>
      <Grid item xs={12}>
        <Divider />
      </Grid>

      <Grid item xs={12}>
        <TextField
          name="name"
          label="Nome"
          fullWidth
          variant="outlined"
          size="small"
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          name="email"
          label="E-mail"
          fullWidth
          variant="outlined"
          size="small"
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          name="login"
          label="Login"
          fullWidth
          variant="outlined"
          size="small"
        />
      </Grid>
      <Grid item xs={6}>
        <Select
          name="status"
          label="Status"
          items={statusItems}
          fullWidth
          variant="outlined"
          size="small"
        />
      </Grid>
    </>
  );
};

export default UserFilters;
